// src/actions/dailyReportActions.js
import api from '../utils/api';

export const FETCH_DAILY_REPORT_SUCCESS = 'FETCH_DAILY_REPORT_SUCCESS';
export const UPDATE_DAILY_REPORT_SUCCESS = 'UPDATE_DAILY_REPORT_SUCCESS';

export const fetchDailyReport = (date) => async (dispatch) => {
  try {
    const res = await api.get(`/daily-reports/${date}`);
    dispatch({
      type: FETCH_DAILY_REPORT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching daily report:', error);
    // Handle error
  }
};

export const updateDailyReport = (dailyReportData) => async (dispatch) => {
  try {
    const res = await api.post('/daily-reports', dailyReportData);
    dispatch({
      type: UPDATE_DAILY_REPORT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error updating daily report:', error);
    // Handle error
  }
};
